class StickyScroller {
  constructor(element) {
    if (!element) {
      // eslint-disable-next-line no-console
      console.error('No element passed to StickyScroller');
      return;
    }

    this.element = element;
    this.previousY = window.scrollY;
    this.initialTop = parseFloat(window.getComputedStyle(this.element).top);
    this.currentTop = 0;

    this.scroll = this.scroll.bind(this);

    window.addEventListener('scroll', this.scroll);
  }

  scroll() {
    const rect = this.element.getBoundingClientRect();
    const topMax = rect.top + window.scrollY - this.element.offsetTop + this.initialTop;
    const topMin = this.element.clientHeight - window.innerHeight;

    if (window.scrollY < this.previousY) {
      this.currentTop -= window.scrollY - this.previousY;
    } else {
      this.currentTop += this.previousY - window.scrollY;
    }

    this.currentTop = Math.min(Math.max(this.currentTop, (topMin * -1)), topMax, this.initialTop);
    this.previousY = window.scrollY;

    this.element.style.top = `${this.currentTop}px`;
  }

  destroy() {
    window.removeEventListener('scroll', this.scroll);
  }
}

export default StickyScroller;
